import classNames from 'classnames';
import { OrdersBasketProductSelector } from 'components/Workspaces/OrdersBasket/Toolbar/OrdersBasketProductSelector';
import { FC } from 'react';

import { OrdersBasketImportButton } from './OrdersBasketImportButton';

interface OrdersBasketToolbarProps {
  productSubType: string;
  productType: string;
  className?: string;
}
export const OrdersBasketToolbarComponentNext: FC<OrdersBasketToolbarProps> = ({
  productSubType,
  productType,
  className,
}) => {
  return (
    <div className={classNames(className, 'd-flex align-items-center justify-content-between')}>
      <OrdersBasketProductSelector />
      <OrdersBasketImportButton productSubType={productSubType} productType={productType} />
    </div>
  );
};
